import { ChangeDetectorRef, Component, ElementRef, HostListener, PLATFORM_ID, ViewChild, inject } from '@angular/core';
import { SoftwareSpecificSearchService } from '../software-specific-search.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { isPlatformBrowser, ViewportScroller } from '@angular/common';
import { FormGroup, FormControl } from '@angular/forms';
import { ViewConfig, ViewModes } from '@spartacus/storefront';
import { BehaviorSubject, Subject } from 'rxjs';
import { ProductListService } from 'src/app/services/feature/product-list.service';
import { RecentSearchService } from 'src/app/services/feature/Recent-Search/recent-search.service';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { KBLanguageService } from 'src/app/services/sapSpartacus/kbLanguageService/KbLang-service.service';

@Component({
  selector: 'app-kb-soft-ware-search-page',
  templateUrl: './kb-soft-ware-search-page.component.html',
  styleUrls: [
    './kb-soft-ware-search-page.component.scss',
    '../../kb-CustomDocumentSearchTab/kb-doc-search-page/kb-doc-search-page.component.scss',
  ],
  standalone: false
})
export class KbSoftWareSearchPageComponent {
  kbDocService = inject(SoftwareSpecificSearchService);
  kbTempService = inject(ProductListService);
  productListService = inject(ProductListService);
  viewportScroller = inject(ViewportScroller);
  scrollConfig = inject(ViewConfig);
  cdr = inject(ChangeDetectorRef);
  bpo = inject(BreakpointObserver);
  private recentSearch = inject(RecentSearchService);
  langservice = inject(KBLanguageService);

  private unsubscribe$ = new Subject<void>();

  ApiData: any;
  ApiDataSearch: any;
  isMobile: boolean = false;

  recentSearches: any[] = [];
  searchInput: string = '';

  isInfiniteScroll: boolean | undefined;

  docModel: any;
  viewMode$ = new BehaviorSubject<ViewModes>(ViewModes.Grid);
  ViewModes = ViewModes;

  currentPage = 0;
  sort = '';
  defaultPageSize = 10;
  avoidPageLoadCall: boolean = false;
  avoidSearchCall = false;
  //software Search form
  platformId = inject(PLATFORM_ID);
  docSearchForm = new FormGroup({
    searchKey: new FormControl(''),
    softwareGroup: new FormControl(null),
    softwareType: new FormControl(null),
    packageType: new FormControl(null),
    softLanguage: new FormControl(null),
  });
  currentcountry: string;
  SearchQuery: string;
  get form() {
    return this.docSearchForm.controls;
  }
  @ViewChild('searchInput') searchInputSoft!: ElementRef;
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedInsideComponent = (event.target as HTMLElement).closest('.softInputSearch');
    if (!clickedInsideComponent) {
      console.warn('HostListener');
      this.hideRecentSearches(); // Hide the dropdown when clicking outside the component
    }
  }

  updateRecentSearches(): void {
    this.recentSearches = this.recentSearch.getRecentSearches('softRecentSearchBox');
  }
  onSearch(event?: Event): void {
    this.recentSearch.saveRecentSearch(this.searchInput, 'softRecentSearchBox');
    this.updateRecentSearches();
  }
  onSearchInput(event: any): void {
    this.searchInput = event.target.value;
    if (this.searchInput.length >= 1) {
      this.hideRecentSearches();
    } else {
      this.showRecentSearches();
    }
  }
  clearRecentSearch(): void {
    this.hideRecentSearches();
  }
  showRecentSearches(): void {
    if (isPlatformBrowser(this.platformId)) {
      const recentSearchPopup = document.querySelector('.RecentSearchSOFTPopUP');
      if (recentSearchPopup) {
        recentSearchPopup.classList.add('show');
      }
    }
  }

  hideRecentSearches(): void {
    if (isPlatformBrowser(this.platformId)) {
      const recentSearchPopup = document.querySelector('.RecentSearchSOFTPopUP');
      if (recentSearchPopup) {
        recentSearchPopup.classList.remove('show');
      }
    }
  }
  populateSearchInput(value: string): void {
    this.docSearchForm.controls['searchKey'].setValue(value);
    this.searchInputSoft.nativeElement.value = value;
    this.hideRecentSearches();
  }
  ngOnInit() {
    if (!this.productListService.fromDetailPage$.getValue()) {
      this.reset();
    }
    this.productListService.fromDetailPage$.next(false);
    this.productListService.selectedTabIndex.next(8);
    this.updateRecentSearches();
    this.bpo.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(takeUntil(this.unsubscribe$)).subscribe((result) => {
      this.isMobile = result.matches;
      if (this.isMobile) {
        this.setViewMode(this.ViewModes.Grid);
      } else {
        this.setViewMode(this.ViewModes.List);
      }
    });
    this.isInfiniteScroll = this.scrollConfig.view?.infiniteScroll?.active;
    this.getSoftwarePageDetails();
    this.langservice
      .getActive()
      .pipe(takeUntil(this.unsubscribe$), distinctUntilChanged())
      .subscribe((langChange) => {
        this.currentcountry = langChange;
      });
  }
  getSoftwarePageDetails() {
    this.kbDocService.getSoftWareSearchPage().pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.ApiDataSearch = data;
      this.avoidPageLoadCall = true;
      this.cdr.detectChanges();
    });
  }
  ngAfterViewInit() {
    this.langservice
      .getActive()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((lang: any) => {
        if (this.avoidPageLoadCall) {
          if (this.avoidSearchCall) {
            this.search(this.currentPage, this.defaultPageSize, this.sort);
          }
          this.getSoftwarePageDetails();
        }
      });
  }
  reset() {
    this.docSearchForm.reset();
    this.clearSearchData();
  }
  search(currentPage: any, pageSize: any, sort: string, model?) {
    this.currentPage = currentPage;
    this.defaultPageSize = pageSize;
    this.sort = sort;
    if (model) {
      this.SearchQuery = this.productListService.DecodeQuery(model?.currentQuery?.query?.value);
    } else {
      this.SearchQuery = this.form.searchKey.value ?? '';
    }
    const ApiPayload = {
      searchKey: this.SearchQuery,
      softwareGroup:
        this.form.softwareGroup.value === null || this.form.softwareGroup.value === 'null'
          ? ''
          : this.form.softwareGroup.value,
      softwareType:
        this.form.softwareType.value === null || this.form.softwareType.value === 'null'
          ? ''
          : this.form.softwareType.value,
      packageType:
        this.form.packageType.value === null || this.form.packageType.value === 'null'
          ? ''
          : this.form.packageType.value,
      language:
        this.form.softLanguage.value === null || this.form.softLanguage.value === 'null'
          ? ''
          : this.form.softLanguage.value,
    };
    this.onSearch();
    this.productListService.getCustomSoftwareDetails(ApiPayload, pageSize, currentPage, sort).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.productListService.seperateSoftDetails$.next(data);
      this.productListService.selectedTabIndex.next(8);
      this.avoidSearchCall = true;
      this.cdr.detectChanges();
    });
  }
  changePageSize(pageSize: any, model) {
    this.defaultPageSize = pageSize;
    this.search(0, pageSize, model.pagination.sort);
  }
  changePage(page: number, model: any) {
    this.currentPage = page;
    this.search(page, model.pagination.pageSize, model.pagination.sort, model);
  }
  sortList(e, model) {
    this.sort = e;
    this.search(0, this.defaultPageSize, e, model);

  }
  changePageCustom(currentPage, model) {
    this.viewportScroller.scrollToPosition([0, 200]);
    this.search(currentPage, this.defaultPageSize, model.pagination.sort, model);
  }
  setViewMode(mode: ViewModes): void {
    this.viewMode$.next(mode);
  }
  ngOnDestroy() {
    //store form data in service for state maintenance
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.kbDocService.formData = this.docSearchForm.value;
    this.productListService.selectedTabIndex.next(0);
  }

  clearSearchData() {
    this.productListService.selectedTabIndex.next(8);
    this.productListService.seperateSoftDetails$.next('NO DATA');
  }
}
